import { render } from "./IOPMedicalTest.vue?vue&type=template&id=54f1c505&scoped=true"
import script from "./IOPMedicalTest.vue?vue&type=script&lang=js"
export * from "./IOPMedicalTest.vue?vue&type=script&lang=js"

import "./IOPMedicalTest.vue?vue&type=style&index=0&id=54f1c505&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54f1c505"]])

export default __exports__